import { FC, memo } from 'react';

import { PQFLVisitCard } from '../../../Cards/PQFLVisitCard';
import { ListCardCollects } from '../styles';
import { IListCardsPQFLVisits } from './types';

const ListCardsPQFLVisits: FC<IListCardsPQFLVisits> = memo(
  ({ data, onVisualize, onPrint }) => {
    return (
      <ListCardCollects>
        {data.map((visit, key) => (
          <PQFLVisitCard
            key={key}
            visit={visit}
            onVisualize={onVisualize}
            onPrint={onPrint}
          />
        ))}
      </ListCardCollects>
    );
  },
);

ListCardsPQFLVisits.displayName = 'ListCardsPQFLVisits';

export { ListCardsPQFLVisits };
